module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-Australia-Website-w960.57687aff.jpg";